import React from "react";
import { Link } from "react-router-dom";
import { add_icon } from "../icons/add";
import { search_icon } from "../icons/search";
import { useAuth } from "../store/authProvider";
import { MultiSelect } from "../components/multiSelect";
import { dropdownStyles } from "../pages/buy/buy";
import Select from "react-select";
import { useTranslation } from "react-i18next";

const SmallSearch = ({
  page,
  onSubmit,
  register,
  categories,
  text,
  state,
  states,
  crop,
  setCrop,
  setState,
  pricesOtions,
  priceSort,
  setPriceSort,
  setPage,
}) => {
  const { t } = useTranslation();
  const { isAuth } = useAuth();
  const to = () => {
    let to;
    switch (page) {
      case 0:
        to = "/addform";
        break;
      case 1:
        to = "/addformOrder";
        break;
      case 4:
        to = "/addInput";
        break;
      case 5:
        to = "/addInputOrder";
        break;
      case 6:
        to = "/add_auction";
        break;
      default:
        to = "/addform";
        break;
    }

    return to;
  };

  return (
    <div className="lg:hidden col-span-2">
      <div className=" flex items-center justify-center h-12  font-bold text-white rounded-[13.5px] shadow-sm  w-full bg-primary mb-4">
        <Link to={isAuth ? to() : "/signin"}>
          <div className="flex flex-row-reverse items-center justify-center ">
            <div className="">{add_icon}</div>
            <div className="">{text}</div>
          </div>
        </Link>
      </div>

      <form onSubmit={onSubmit} className="mb-[12px]">
        <div className="rounded-full w-full border-[1px] border-secondary h-[49px] flex justify-end items-center px-3  ">
          <input
            type="text"
            {...register("search_words")}
            className="border-0 bg-transparent w-full focus:ring-0 text-gray-400 font-bold placeholder:text-sm placeholder:text-gray-400"
            dir="rtl"
            // placeholder="أبحث عن طلبك..."
            placeholder={t("common.request_search_placeholder")}
          />
          {search_icon}
        </div>
        <input className="hidden" type="submit" />
      </form>

      <form onClick={onSubmit} className="flex flex-col lg:flex-row gap-3">
        <MultiSelect
          options={categories.map((e) => {
            return { label: e.name, value: e.id };
          })}
          value={crop}
          onChange={setCrop}
          styles={dropdownStyles}
          // placeHolder="المحاصيل"
          placeHolder={t("common.crops")}
        />
        <MultiSelect
          options={states.map((e) => {
            return { label: e.name, value: e.id };
          })}
          value={state}
          onChange={setState}
          styles={dropdownStyles}
          // placeHolder="المناطق"
          placeHolder={t("common.regions")}
        />
        <Select
          isRtl={true}
          options={[
            { label: t("common.newest"), value: "" },
            { label: t("common.price_asc"), value: "asc" },
            { label: t("common.price_desc"), value: "desc" },
          ]}
          value={
            [
              { label: t("common.newest"), value: "" },
              { label: t("common.price_asc"), value: "asc" },
              { label: t("common.price_desc"), value: "desc" },
            ].find((opt) => opt.value === priceSort) || null
          }
          onChange={(selected) => {
            setPage(1);
            setPriceSort(selected?.value ?? null); // Only store value
          }}
          styles={dropdownStyles}
          // placeholder="الاحدث"
          placeholder={t("common.newest")}
        />
      </form>
    </div>
  );
};

export default SmallSearch;
